var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 4,
    viewBox: "0 0 28 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6669 3.33304L26.6669 3.33304C27.4041 3.33377 28.0007 2.7371 28 1.99999C28 1.26215 27.4041 0.666204 26.6669 0.666932L12.6669 0.666931L1.33306 0.666932C0.595946 0.666204 0 1.26215 0 1.99999C0 2.36818 0.148441 2.70144 0.390021 2.94302C0.631601 3.1846 0.965592 3.33377 1.33306 3.33304L12.6669 3.33304Z",
    fill: "#23252E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.bc66dcc9.svg";
export { ForwardRef as ReactComponent };